import { createSlice } from "@reduxjs/toolkit";
import { FilterStateAccessRequest } from "./types";

const INITIAL_STATE: FilterStateAccessRequest = {
  filters: {
    search: "",
    store_code: "",
    status: "",
    from_date: "",
    to_date: "",
    orderBy: {},
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const accessRequestFilterSlice = createSlice({
  name: "accessRequestFilter",
  initialState: INITIAL_STATE,
  reducers: {
    setAccessRequestFilter(state, action) {
      const { key, value } = action.payload;
      
      if (key === 'meta') {
        state.filters.meta = {
          ...state.filters.meta,
          ...value,
        };
      } else {
        state.filters[key] = value;
      }
    },
    clearAccessRequestFilters(state) {
      state.filters = { ...INITIAL_STATE.filters };
    },
  },
});

export const { 
  setAccessRequestFilter, 
  clearAccessRequestFilters 
} = accessRequestFilterSlice.actions;

export default accessRequestFilterSlice.reducer;